import { render, staticRenderFns } from "./actionsBox.vue?vue&type=template&id=047a1a32&scoped=true"
import script from "./actionsBox.vue?vue&type=script&lang=js"
export * from "./actionsBox.vue?vue&type=script&lang=js"
import style0 from "./actionsBox.vue?vue&type=style&index=0&id=047a1a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047a1a32",
  null
  
)

export default component.exports